export const checkedCardReducerStepTwo = (state = "", action) => {
    switch (action.type) {
        case 'CHECK_CARD_STEP_TWO':
            state = (state === action.payload) ? "" : action.payload
            return state
        default:
            return state
    }
}